<nav class="navbar navbar-expand bg-neutrals-50 border-top shadow-sm w-100 px-4 fixed-top d-none d-lg-block"
    style="top: 102px; z-index: 1020;">
    <div class="container-fluid justify-content-start">
        <ul class="nav nav-tabs border-0 w-100">
            @for (item of menuItems; track item.route) {
            <li class="nav-item">
                <a class="nav-link" [class.active]="isActive(item.route)" (click)="scrollToSection(item.route, $event)"
                    style="cursor: pointer;">
                    {{ item.label }}
                </a>
            </li>
            }
        </ul>
    </div>
</nav>